import { isUserSessionSetup } from '@/common/services/account/userSession';
import { Accessibles } from '@/common/services/account/types';

const PageHomeAnalytics = (): Promise<unknown> =>
  import('@/features/analytics/pages/home/AnalyticsView.vue');

export default [
  {
    path: '/volunteers/analytics',
    component: PageHomeAnalytics,
    meta: {
      hasSideBar: true,
      guard: (accessibles: Accessibles) => {
        if (!isUserSessionSetup() || !accessibles.units.length) {
          return false;
        }

        return true;
      }
    }
  },
  {
    path: '/view',
    redirect: '/volunteers/analytics'
  },
  {
    path: '/view/*',
    redirect: '/volunteers/analytics'
  }
];
